<div class="row" >
  <div class="col-lg-3 col-md-6 col-sm-6 col-12 mb-2" style="display: flex;">
    <div class="dot gray"></div>
    <div>&nbsp; คอร์สเรียนในอนาคต</div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6 col-12 mb-2" style="display: flex;">
    <div class="dot blue"></div>
    <div>&nbsp; คอร์สเรียนที่ยังไม่ได้สมัคร</div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6 col-12 mb-2" style="display: flex;">
    <div class="dot pink"></div>
    <div>&nbsp; คอร์สเรียนที่ยังเรียนไม่จบ</div>
  </div>

  <div class="col-lg-3 col-md-6 col-sm-6 col-12 mb-2" style="display: flex;">
    <div class="dot green"></div>
    <div>&nbsp; คอร์สเรียนที่เรียนจบแล้ว</div>
  </div>
</div>
